import { render } from "./CreateOrder.vue?vue&type=template&id=07d4a1e2&scoped=true&ts=true"
import script from "./CreateOrder.vue?vue&type=script&lang=ts"
export * from "./CreateOrder.vue?vue&type=script&lang=ts"

import "./CreateOrder.vue?vue&type=style&index=0&id=07d4a1e2&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d4a1e2"]])

export default __exports__